// @ts-nocheck legacy file transformed to TS
import LoadingDots from '../LoadingDots'

const TableLoader = () => <LoadingDots height={10} centered />

export default TableLoader
